export const removeEndingIn = (name: string) => {
  return name.replaceAll('ending in', '');
};
